import React from 'react';
import { render } from 'react-dom';
import PartnerApp from './partnersApp/App';
import './partner.css';

render(
  <React.StrictMode>
    <PartnerApp />
  </React.StrictMode>,
  document.getElementById('root'),
);
